/**
 * Normalizes the `queryKey` prop of the base table components.
 *
 * Tables historically passed a scalar string (`X_TABLE_CONSTANTS.queryKey`) and
 * the table composed the array itself. Key factories return an array instead,
 * so both shapes have to work while tables migrate one at a time. A scalar
 * produces the same single-element root as before, leaving an unmigrated
 * table's cache entries byte-identical.
 */
export const tableRootKey = queryKey =>
  Array.isArray(queryKey) ? queryKey : [queryKey];
